import { Component, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { TruckOwnerService } from "../truck-owner.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { AddRoutesComponent } from "../add-routes/add-routes.component";
import { response } from "express";
import { catchError, of } from "rxjs";

@Component({
  selector: "app-preorder-settings",
  templateUrl: "./preorder-settings.component.html",
  styleUrls: ["./preorder-settings.component.css"],
})
export class PreorderSettingsComponent implements OnInit {
  token: any;
  profilePic: any = "";
  truckOwner: any;
  Matdialogref!: MatDialogRef<AddRoutesComponent>;
  routesData: any[] = [];
  pickupCitiesData: any[] = [];
  truckCategory: any = [];
  loading: boolean = false;

  constructor(
    private router: Router,
    private matDialog: MatDialog,
    private services: TruckOwnerService,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.token = sessionStorage.getItem("to_token");
    this.getProfile();
    this.getPreorder();
    this.truckOwnerGet();
    this.getTruckCategory();
  }

  GoToProfile() {
    sessionStorage.removeItem("preorder_setting");
    // sessionStorage.removeItem("preorder");
    this.router.navigateByUrl("transporter/profile");
  }

  logout() {
    sessionStorage.clear();
    this.services.logoutTransporter(this.token).subscribe(
      (response: any) => {
        if (response.status == 200) {
          this.router.navigateByUrl("/");
          this.snackBar.open("Account logout successfully", "Success", {
            duration: 3000,
          });
        }
      },
      (error) => {
        {
          this.router.navigateByUrl("/");
          sessionStorage.clear();
        }
      }
    );
  }
  getTruckCategory() {
    this.services.getCategory().subscribe(
      (response: any) => {
        if (response && response.data && Array.isArray(response.data)) {
          this.truckCategory = [...response.data]; // Populate all categories
        } else {
        }
      },
      (error) => { }
    );
  }

  truckOwnerGet() {
    this.services.GettruckOwner(this.token).subscribe((response: any) => {
      this.truckOwner = response.body.data;
    });
  }

  public getProfile() {
    this.services.profileGet(this.token).subscribe((response: any) => {
      this.profilePic = response.body.data.profile_pic;
    });
  }

  GoToOrders() {
    sessionStorage.removeItem("preorder");
    this.router.navigateByUrl("transporter/orders");
  }

  goToNotifications() {
    this.router.navigateByUrl("transporter/notifications");
  }

  deletepreOrder(data: any) {
    this.loading = true; // Show the loader while the deletion is processing

    this.services.deletePreOrderSetting(data._id, this.token).subscribe(
      (response: any) => {
        // Handle successful deletion
        this.snackBar.open("Deleted successfully", "Close", {
          duration: 3000,
          // verticalPosition: "top",
          panelClass: ["success-snackbar"],
        });

        // Update the data locally without refreshing
        if (data.pre_order_type === "route") {
          this.routesData = this.routesData.filter(
            (item: any) => item._id !== data._id
          );
        } else if (data.pre_order_type === "pickup_city") {
          this.pickupCitiesData = this.pickupCitiesData.filter(
            (item: any) => item._id !== data._id
          );
        }

        this.loading = false; // Stop the loader
      },
      (error) => {
        // Handle errors
        this.loading = false;
        this.snackBar.open(
          "Error deleting record. Please try again.",
          "Close",
          {
            duration: 3000,
            verticalPosition: "top",
            panelClass: ["error-snackbar"],
          }
        );
      }
    );
  }

  getPreorder() {
    this.loading = true; // Show the loader while fetching data

    this.services
      .preOrderSetting(this.token)
      .pipe(
        catchError((error: any) => {
          // Handle the error case
          this.loading = false; // Stop the loader
          if (error.status === 404) {
            this.snackBar.open("No Records Found", "Close", {
              duration: 3000,
              // verticalPosition: "top", // Adjust position if needed
              panelClass: ["error-snackbar"], // Add custom styles if needed
            });
          } else {
            this.snackBar.open(
              "An error occurred. Please try again.",
              "Close",
              {
                duration: 3000,
                verticalPosition: "top",
                panelClass: ["error-snackbar"],
              }
            );
          }
          return of({ body: { data: [] } }); // Return empty data so app can continue
        })
      )
      .subscribe((response: any) => {
        this.loading = false; // Stop the loader after API call
        // Process the successful response
        if (response.body?.data?.length) {
          response.body.data.forEach((preOrder: any) => {
            const category = this.truckCategory.find(
              (cat: any) => cat._id === preOrder.truck_category
            );
            if (category) {
              preOrder.truck_category_name = category.truck_category_name;
            }
          });

          // Separate the data based on `pre_order_type`
          this.routesData = response.body.data.filter(
            (item: any) => item.pre_order_type === "route"
          );
          this.pickupCitiesData = response.body.data.filter(
            (item: any) => item.pre_order_type === "pickup_city"
          );
        }
      });
  }
  addRoutes() {
    this.Matdialogref = this.matDialog.open(AddRoutesComponent, {
      width: "25vw",
      height: "auto",
      disableClose: true, // Prevents dialog from closing when clicking outside
      autoFocus: false,
    });
    this.Matdialogref.afterClosed().subscribe((x) => {
      this.getPreorder();
    });
  }
}
